import Divider from "../../componets/Divider";

export default function Section2() {
  return (
    <div className="Section2">
      <div className="w-[90%] my-[24px] md:my-0 md:w-[61%] mx-auto text-center">
        <h1 className="text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-[#151515] mt-[40px]">
          Crafting Seamless Experiences <br></br> <span className="text-[#DA2128]">UI/UX Design Services</span>
        </h1>

        <p className="pt-[1%] leading-[20px] text-[#535353] font-open text-[16px]">
          In today's digital landscape, user experience (UX) and user interface
          (UI) design are more critical than ever. At Mean3, we specialize in
          creating intuitive, visually appealing, and user-centric digital
          experiences that captivate your audience and drive results. Whether
          you're launching a new product or enhancing an existing one, our team
          is here to transform your vision into an engaging reality.
        </p>
      </div>

      <Divider />
    </div>
  );
}
